import { Column, H1 } from '@alto/design-system';
import React from 'react';

type Props = {
  readonly children: string;
};

export const PageHeader: React.FC<Props> = ({ children }) => {
  return (
    <Column centerVertically>
      <H1>{children}</H1>
    </Column>
  );
};
